import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';

// Screens
import CommunicationJobDetails from './screens/CommunicationJobDetails/CommunicationJobDetails';
import RescheduleJobDetails from './screens/RescheduleJobDetails/RescheduleJobDetails';
import JobsList from './screens/JobsList/JobsList';


const routes = [
  {
    path: '/practitioner/jobs',
    component: JobsList,
  },
  {
    path: '/practitioner/jobs/job-details/communicate/:jobId',
    component: CommunicationJobDetails,
  },
  {
    path: '/practitioner/jobs/job-details/reschedule/:jobId',
    component: RescheduleJobDetails,
  },
];


const RegistrationRoutings = ({ screenProps }) => (
  <Fragment>
    <Switch>
      {routes.map((route) => (
        <Route
          exact
          key={`${route.path}`}
          path={route.path}
          render={(props) => (
            <route.component {...props} {...screenProps} />
          )}
        />
      ))}
      <Redirect to="/404" />
    </Switch>
  </Fragment>
);
RegistrationRoutings.propTypes = {
  screenProps: PropTypes.shape({
    regData: PropTypes.shape(),
    updateUserData: PropTypes.func,
  }),
};
RegistrationRoutings.defaultProps = {
  screenProps: null,
};

export default RegistrationRoutings;
